import styled from 'styled-components';

/**
 * Over the turn banner and hand while replaying: the panel underneath keeps its height, so the board keeps its size.
 */
export const ReplayOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  /* A big hand wraps onto more rows (ReplayHand); past the panel's height it scrolls. */
  overflow-y: auto;
  background: #102419;
  border-top: 1px solid var(--line);
`;

/** Which move this is. */
export const Position = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: var(--muted);
`;

/** The move in words, a fixed height so nothing below jumps from move to move. */
export const Lines = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  height: 3.9em;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.3;
`;

export const Steps = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;

export const StepButton = styled.button`
  min-width: 64px;
  height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  background: ${({ $primary }) => ($primary ? '#ffcb05' : 'rgba(255, 255, 255, .1)')};
  color: ${({ $primary }) => ($primary ? '#1b1b1b' : 'var(--text, #f4f1e8)')};

  &:disabled {
    opacity: .35;
    cursor: default;
  }
`;

/** Your hand as it was then, in one scrolling row like the real one. */
export const ReplayHand = styled.ul`
  --card-w: 56px;
  list-style: none;
  margin: 2px 0 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  min-height: calc(var(--card-w) * 825 / 600);
`;
